import { render, staticRenderFns } from "./dueloans.vue?vue&type=template&id=0e55b625"
import script from "./dueloans.vue?vue&type=script&lang=js"
export * from "./dueloans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports